module.exports = __webpack_public_path__ + "img/item-banner-4.b32ab058.png";